import { types, castToSnapshot } from 'mobx-state-tree';
import { createContext } from 'react';
import { uiStore, UiStore } from './UiStore';
import { userStore, UserStore } from './UserStore';
import { activityTypeStore, ActivityTypeStore } from './ActivityTypeStore';
import { cropStore, CropStore } from './CropStore';
import { organizationsStore, OrganizationsStore } from './OrganizationsStore';
export const RootStore = types.model('RootStore', {
  userStore: types.optional(UserStore, () => UserStore.create()),
  uiStore: types.optional(UiStore, () => UiStore.create()),
  activityTypeStore: types.optional(ActivityTypeStore, () => ActivityTypeStore.create({})),
  cropStore: types.optional(CropStore, () => CropStore.create({})),
  organizationsStore: types.optional(OrganizationsStore, () => OrganizationsStore.create({}))
});
export const rootStore = RootStore.create({
  userStore: castToSnapshot(userStore),
  uiStore: castToSnapshot(uiStore),
  cropStore: castToSnapshot(cropStore),
  activityTypeStore: activityTypeStore,
  organizationsStore: castToSnapshot(organizationsStore)
});
export const RootStoreContext = createContext(rootStore);